/**
 *  @class
 *  @function SizeSystem
 */
if (!customElements.get('size-system')) {
    class SizeSystem extends HTMLElement {
        constructor() {
        super();
        this.buttons = this.querySelectorAll('.size__switcher button[data-size-system]');
        this.spans = this.querySelectorAll('span[data-size-system]');
    }

      connectedCallback() {
      this.addEventListeners();
    }
    addEventListeners() {
      this.buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          // Remove .active from all buttons
          this.buttons.forEach(b => b.classList.remove('active'));
          // Add .active to the clicked button
          btn.classList.add('active');

          // Show corresponding spans
          this.showSystem(btn.dataset.sizeSystem);
        });

        
      });
    }
    showSystem(system) {
      this.spans.forEach(span => {
        // Add .active only to the spans for the selected system
        span.classList.toggle('active', span.dataset.sizeSystem === system);
      });
    }
}

  customElements.define('size-system', SizeSystem);
}
